const Routes = {
  root: '/',
  landing: '/landing',
  lobby: '/main-lobby',
  booth: (boothId) => (boothId ? `/booth/${boothId}` : '/booth/:boothId'),
  hall: '/hall',
  webinar: '/webinar',
  search: '/search',
};

export default Routes;
